/**
 * @file Date based entity list component.
 * @author Wim Haanstra
 */
import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { empty } from 'rxjs';
import { ListBase } from '../../base/list/list.base';
import { DialogService } from '../../core/dialog.service';
import { AlertsService } from '../../core/alerts.service';
import { BreezeService } from '../../core/breeze.service';
import { OverlayService } from '../../core/overlay.service';
import { LocalStorageService } from '../../core/local-storage.service';
import { EventsService } from '../../core/event.service';
import { GridService } from '../grid.service';
import { detailLevelDay } from '../helpers/detail-levels';
import { UserService } from '../../user.service';
import { mergeMap } from 'rxjs/operators';
import { ActionService } from '../../core/action.service';
/**
 * Date based entity list component.
 * @export
 * @class AgendaListComponent
 * @extends {ListBase}
 */
var AgendaListComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AgendaListComponent, _super);
    /**
     * Constructs a AgendaListComponent.
     * @param configurationsService Service to get the configuration of this component.
     * @param domainService Service to load and save entity data.
     * @param dialogService Service for displaying dialogs.
     * @param alertsService Service for publish alerts.
     * @param router Service for routing events.
     */
    function AgendaListComponent(userService, domainService, // TODO: remove this Inject construction
    dialogService, alertsService, translateService, router, overlayService, localStorageService, eventsService, gridService, actionService) {
        var _this = _super.call(this, userService, domainService, dialogService, alertsService, translateService, router, overlayService, localStorageService, eventsService, actionService) || this;
        _this.gridService = gridService;
        _this.subscriptionPool.add(_this.gridService.stateChanged
            .pipe(mergeMap(function () {
            if (_this.entityType) {
                // When this._objects.entityType then DataSet registered.
                var result = _this.refresh();
                return result ? result : empty();
            }
            else {
                return empty();
            }
        }))
            .subscribe(function () {
            // Selected PlanItem can be excluded when new period is chosen.
            // So we deselect.
            _this.select(null);
        }));
        return _this;
    }
    Object.defineProperty(AgendaListComponent.prototype, "start", {
        /**
         * Gets the start date of the horizon.
         * @readonly
         * @type {moment.Moment}
         * @memberOf AgendaListComponent
         */
        get: function () {
            return this.gridService.startDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgendaListComponent.prototype, "finish", {
        /**
         * Gets the end date of the horizon.
         * @readonly
         * @type {moment.Moment}
         * @memberOf AgendaListComponent
         */
        get: function () {
            return this.gridService.endDate;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Method to retrieve the requested entities from the back-end API.
     * @returns An observable object that retrieves the requested entities.
     */
    AgendaListComponent.prototype.refresh = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.overlayMode) {
                    this.gridService.level = detailLevelDay;
                }
                return [2 /*return*/, _super.prototype.refresh.call(this)];
            });
        });
    };
    return AgendaListComponent;
}(ListBase));
export { AgendaListComponent };
